var map = {
	"./B2cEurope.png": "7e50",
	"./Bring.png": "7c85",
	"./DHLNL.png": "c031",
	"./Dao.png": "8e59",
	"./DhlNl.png": "e4b6",
	"./DhlSe.png": "7fad",
	"./EarlyBird.png": "6687",
	"./GLS.png": "7647",
	"./Gls.png": "8729",
	"./Hermes.png": "9ed4",
	"./OneWorldExpress.png": "90f0",
	"./PostNL.png": "ea9d",
	"./PostNl.png": "59f6",
	"./PostNord.png": "f168",
	"./Posti.png": "3938",
	"./Skynet.png": "6130",
	"./StarLinks.png": "8e31",
	"./Usps.png": "056d",
	"./confirm-icon.png": "87b7",
	"./logo.png": "9d64",
	"./warning-icon.png": "395a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";